export async function getPublicKey() {
  const url = `${process.env.NEXT_PUBLIC_BASE_URL}/app/v1/public-key`;
  /* console.log("[getPublicKey] Fetching from:", url); */

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Accept: "text/plain",
    },
  });

  /* console.log("[getPublicKey] Response status:", response.status);
  console.log("[getPublicKey] Content-Type:", response.headers.get("content-type")); */

  if (!response.ok) {
    throw new Error(`Failed to fetch public key: ${response.status}`);
  }

  const pem = await response.text();
  /* console.log("[getPublicKey] Raw PEM:", pem.slice(0, 100) + "..."); // only show first 100 chars */

  if (!pem.includes("-----BEGIN PUBLIC KEY-----")) {
    throw new Error("Invalid PEM format received.");
  }

  return pem;
}
